// This file is auto-generated by @hey-api/openapi-ts

export {
  apiSchemaRetrieve,
  backgroundTasksTasksRetrieve,
  directoutreachBetanxtVoterPolicySnapshotExportCreate,
  directoutreachPolicyAvailableList,
  directoutreachPolicyAvailableRetrieve,
  directoutreachPolicyCreate,
  directoutreachVotersBatchCreateCreate,
  directoutreachVotersCreateCreate,
  directoutreachVotersHoldingsRetrieve,
  directoutreachVotersRetrieve,
  directoutreachVotersSelectedPolicyCreate,
  directoutreachVotersSelectedPolicyRetrieve,
  fundManagerFundManagersCreate,
  fundManagerFundManagersRetrieve,
  fundManagerFundManagersSearchCreate,
  fundManagerFundManagersUpdate,
  fundManagerFundsCreate,
  fundManagerFundsQuantificationSnapshotsCreate,
  fundManagerFundsRetrieve,
  fundManagerFundsSearchCreate,
  fundManagerFundsUpdate,
  fundManagerFundVariantsCreate,
  fundManagerFundVariantsDestroy,
  fundManagerFundVariantsRetrieve,
  fundManagerFundVariantsSearchCreate,
  fundManagerFundVariantsUpdate,
  fundManagerProvidersCreate,
  fundManagerProvidersList,
  fundManagerProvidersRetrieve,
  fundManagerProvidersUpdate,
  fundManagerQuantificationSnapshotsSearchCreate,
  institutionalMeetingsearchList,
  type Options,
  proxyIntermediaryProposalLabelsAssignCreate,
  proxyIntermediaryProposalLabelsFetchCreate,
  proxyvotingEntitlementsBreakdownCreate,
  proxyvotingEntitlementsComputeCreate,
  proxyvotingEntitlementsList,
  proxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreate,
  proxyvotingFundManagerSupportedPoliciesCreate,
  proxyvotingFundManagerSupportedPoliciesDestroy,
  proxyvotingFundManagerSupportedPoliciesList,
  proxyvotingInvestorCompositionsDifferenceList,
  proxyvotingInvestorCompositionsRenderCreate,
  proxyvotingInvestorCompositionsRulesEngineRetrieve,
  proxyvotingInvestorCompositionsRulesEngineUpdate,
  proxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsSearchCreate,
  proxyvotingMeetingballotsComputeCreate,
  proxyvotingMeetingBallotsList,
  proxyvotingMeetingBallotSourcesList,
  proxyvotingPiballotsFilterList,
  proxyvotingPiballotsInvestorsCanVoteCreate,
  proxyvotingPimeetingsFilterList,
  proxyvotingRulesEngineDefinitionsByNameDestroy,
  proxyvotingRulesEngineDefinitionsCreate,
  proxyvotingRulesEngineDefinitionsDestroy,
  proxyvotingRulesEngineDefinitionsList,
  proxyvotingRulesEngineDefinitionsNamesRetrieve,
  proxyvotingRulesEngineDefinitionsRetrieve,
  proxyvotingRulesEngineDefinitionsRulesCreate,
  proxyvotingRulesEngineDefinitionsRulesDestroy,
  proxyvotingRulesEngineDefinitionsRulesList,
  proxyvotingRulesEngineDefinitionsRulesUpdate,
  proxyvotingSviProposalOverwriteCreate,
  proxyvotingSviProposalOverwriteReasonsList,
  transparencyAuditEventsSearchCreate,
  transparencyExternalMeetingIdsCreate,
  transparencyExternalMeetingIdsDestroy,
  transparencyGeneralMeetingsCreate,
  transparencyGeneralMeetingsPartialUpdate,
  transparencyGeneralMeetingsRetrieve,
  transparencyGeneralMeetingsSearchCreate,
  transparencyInstrumentsCreate,
  transparencyInstrumentsDestroy,
  transparencyInstrumentsFetchMinimalCreate,
  transparencyInstrumentsRetrieve,
  transparencyInstrumentsSearchCreate,
  transparencyInstrumentsUnassociatedRetrieve,
  transparencyInstrumentsUpdate,
  transparencyOrganizationsCreate,
  transparencyOrganizationsDestroy,
  transparencyOrganizationsGeneralMeetingsProposalsCreate,
  transparencyOrganizationsGeneralMeetingsProposalsPartialUpdate,
  transparencyOrganizationsGeneralMeetingsProposalsRetrieve,
  transparencyOrganizationsGeneralMeetingsProposalsSearchCreate,
  transparencyOrganizationsGeneralMeetingsProposalsUpdate,
  transparencyOrganizationsGetByIdentifierCreate,
  transparencyOrganizationsIsinsToNamesCreate,
  transparencyOrganizationsLogoCreate,
  transparencyOrganizationsPartialUpdate,
  transparencyOrganizationsRetrieve,
  transparencyOrganizationsSearchCreate,
  transparencyOrganizationsUpdate,
  transparencyProposalsClassificationCodesRetrieve,
  transparencyProposalsCountCreate,
  transparencyProposalsFetchCreate,
  transparencyProposalsFetchNamesFromIdsCreate,
  transparencyProposalsSecClassificationCodesRetrieve,
  transparencyPublicSecurityIdsSearchCreate,
  votingOperationsPiballotsFilterList,
  votingOperationsPimeetingsFilterList,
  votingPolicyProviderVotingRecommendationsCreate,
  votingPolicyProviderVotingRecommendationsDestroy,
  votingPolicyProviderVotingRecommendationsFetchByVersionRetrieve,
  votingPolicyProviderVotingRecommendationsMatchCreate,
  votingPolicyProviderVotingRecommendationsSearchCreate,
  votingPolicyVotingPoliciesCreate,
  votingPolicyVotingPoliciesDestroy,
  votingPolicyVotingPoliciesDocumentsCreate,
  votingPolicyVotingPoliciesDocumentsList,
  votingPolicyVotingPoliciesDocumentsPartialUpdate,
  votingPolicyVotingPoliciesDocumentsRetrieve,
  votingPolicyVotingPoliciesPartialUpdate,
  votingPolicyVotingPoliciesRetrieve,
  votingPolicyVotingPoliciesSearchCreate,
  votingPolicyVotingPoliciesVotingRecommendationsCreate,
  votingPolicyVotingPoliciesVotingRecommendationsDestroy,
  votingPolicyVotingPoliciesVotingRecommendationsList,
  votingPolicyVotingPoliciesVotingRecommendationsPartialUpdate,
  votingPolicyVotingPoliciesVotingRecommendationsRetrieve,
  votingPolicyVotingPoliciesVotingRecommendationsSearchCreate,
  votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreate,
  votingPolicyVotingRecommendationConfidenceScoresUpdate,
} from './sdk.gen'
export {
  type ApiSchemaRetrieveData,
  type ApiSchemaRetrieveResponse,
  type ApiSchemaRetrieveResponses,
  type AssignProposalLabelRequest,
  type AssignProposalLabelResponse,
  type AuditEvent,
  type AuditEventSearchRequestRequest,
  AvailableToInvestorTypeEnum,
  type BackgroundTasksTasksRetrieveData,
  type BackgroundTasksTasksRetrieveErrors,
  type BackgroundTasksTasksRetrieveResponse,
  type BackgroundTasksTasksRetrieveResponses,
  type BallotEntitlement,
  type BallotEntitlementWritable,
  type BallotInvestorsCanVote,
  type BatchIsinsToOrganizationNamesRequestRequest,
  type BatchIsinsToOrganizationNamesResponse,
  type BatchVoterWithHoldingsInputRequest,
  type BatchVoterWithHoldingsResponse,
  type BatchVoterWithHoldingsResponseWritable,
  BioSourceEnum,
  type BreakdownResponse,
  type ClientOptions,
  type ComponentDiff,
  type ComponentDiffRequest,
  type CompositionDifferenceResponse,
  ComputeBreakdownRequestInvestorTypeEnum,
  type ComputeBreakdownRequestRequest,
  CurrentlyVotableFilterEnum,
  DecisionEnum,
  DiffFormatEnum,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateData,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses,
  type DirectoutreachPolicyAvailableListData,
  type DirectoutreachPolicyAvailableListResponse,
  type DirectoutreachPolicyAvailableListResponses,
  type DirectoutreachPolicyAvailableRetrieveData,
  type DirectoutreachPolicyAvailableRetrieveResponse,
  type DirectoutreachPolicyAvailableRetrieveResponses,
  type DirectoutreachPolicyCreateData,
  type DirectoutreachPolicyCreateResponse,
  type DirectoutreachPolicyCreateResponses,
  type DirectoutreachVotersBatchCreateCreateData,
  type DirectoutreachVotersBatchCreateCreateErrors,
  type DirectoutreachVotersBatchCreateCreateResponse,
  type DirectoutreachVotersBatchCreateCreateResponses,
  type DirectoutreachVotersCreateCreateData,
  type DirectoutreachVotersCreateCreateResponse,
  type DirectoutreachVotersCreateCreateResponses,
  type DirectoutreachVotersHoldingsRetrieveData,
  type DirectoutreachVotersHoldingsRetrieveErrors,
  type DirectoutreachVotersHoldingsRetrieveResponse,
  type DirectoutreachVotersHoldingsRetrieveResponses,
  type DirectoutreachVotersRetrieveData,
  type DirectoutreachVotersRetrieveErrors,
  type DirectoutreachVotersRetrieveResponse,
  type DirectoutreachVotersRetrieveResponses,
  type DirectoutreachVotersSelectedPolicyCreateData,
  type DirectoutreachVotersSelectedPolicyCreateErrors,
  type DirectoutreachVotersSelectedPolicyCreateResponse,
  type DirectoutreachVotersSelectedPolicyCreateResponses,
  type DirectoutreachVotersSelectedPolicyRetrieveData,
  type DirectoutreachVotersSelectedPolicyRetrieveErrors,
  type DirectoutreachVotersSelectedPolicyRetrieveResponse,
  type DirectoutreachVotersSelectedPolicyRetrieveResponses,
  type ExportResult,
  type ExternalMeetingId,
  type ExternalMeetingIdCreateRequest,
  type FetchMinimalInstrumentsRequestRequest,
  type FetchMinimalInstrumentsResponse,
  type FetchMinimalInstrumentsResponseWritable,
  type FetchProposalLabelsRequest,
  type FetchProposalLabelsResponse,
  FilterReasonsEnum,
  type Fund,
  type FundCustodianIdentifiers,
  type FundCustodianIdentifiersRequest,
  type FundManager,
  type FundManagerFundManagersCreateData,
  type FundManagerFundManagersCreateResponse,
  type FundManagerFundManagersCreateResponses,
  type FundManagerFundManagersRetrieveData,
  type FundManagerFundManagersRetrieveResponse,
  type FundManagerFundManagersRetrieveResponses,
  type FundManagerFundManagersSearchCreateData,
  type FundManagerFundManagersSearchCreateResponse,
  type FundManagerFundManagersSearchCreateResponses,
  type FundManagerFundManagersUpdateData,
  type FundManagerFundManagersUpdateResponse,
  type FundManagerFundManagersUpdateResponses,
  type FundManagerFundsCreateData,
  type FundManagerFundsCreateResponse,
  type FundManagerFundsCreateResponses,
  type FundManagerFundsQuantificationSnapshotsCreateData,
  type FundManagerFundsQuantificationSnapshotsCreateResponse,
  type FundManagerFundsQuantificationSnapshotsCreateResponses,
  type FundManagerFundsRetrieveData,
  type FundManagerFundsRetrieveResponse,
  type FundManagerFundsRetrieveResponses,
  type FundManagerFundsSearchCreateData,
  type FundManagerFundsSearchCreateResponse,
  type FundManagerFundsSearchCreateResponses,
  type FundManagerFundsUpdateData,
  type FundManagerFundsUpdateResponse,
  type FundManagerFundsUpdateResponses,
  type FundManagerFundVariantsCreateData,
  type FundManagerFundVariantsCreateResponse,
  type FundManagerFundVariantsCreateResponses,
  type FundManagerFundVariantsDestroyData,
  type FundManagerFundVariantsDestroyResponse,
  type FundManagerFundVariantsDestroyResponses,
  type FundManagerFundVariantsRetrieveData,
  type FundManagerFundVariantsRetrieveResponse,
  type FundManagerFundVariantsRetrieveResponses,
  type FundManagerFundVariantsSearchCreateData,
  type FundManagerFundVariantsSearchCreateResponse,
  type FundManagerFundVariantsSearchCreateResponses,
  type FundManagerFundVariantsUpdateData,
  type FundManagerFundVariantsUpdateResponse,
  type FundManagerFundVariantsUpdateResponses,
  type FundManagerPolicySii,
  type FundManagerPolicySiiBatchCreateRequest,
  type FundManagerPolicySiiBatchDeleteRequest,
  type FundManagerPolicySiiInputRequest,
  type FundManagerPolicySiiResponse,
  type FundManagerPolicySiiResponseWritable,
  type FundManagerPolicySiiSearchRequestRequest,
  type FundManagerPolicySiiWritable,
  type FundManagerProvidersCreateData,
  type FundManagerProvidersCreateResponse,
  type FundManagerProvidersCreateResponses,
  type FundManagerProvidersListData,
  type FundManagerProvidersListResponse,
  type FundManagerProvidersListResponses,
  type FundManagerProvidersRetrieveData,
  type FundManagerProvidersRetrieveResponse,
  type FundManagerProvidersRetrieveResponses,
  type FundManagerProvidersUpdateData,
  type FundManagerProvidersUpdateResponse,
  type FundManagerProvidersUpdateResponses,
  type FundManagerQuantificationSnapshotsSearchCreateData,
  type FundManagerQuantificationSnapshotsSearchCreateResponse,
  type FundManagerQuantificationSnapshotsSearchCreateResponses,
  type FundManagerSearchRequestRequest,
  type FundManagerSupportedIssuedInstrumentsQueryRequest,
  type FundManagerSupportedVotingPolicy,
  type FundManagerSupportedVotingPolicyBatchUpsertRequest,
  type FundManagerSupportedVotingPolicyBatchUpsertResponse,
  type FundManagerSupportedVotingPolicyBatchUpsertResponseWritable,
  type FundManagerSupportedVotingPolicyHistorical,
  type FundManagerSupportedVotingPolicyItemRequest,
  type FundManagerWritable,
  type FundManagerWriteRequest,
  type FundProxyIntermediaryIdentifiers,
  type FundProxyIntermediaryIdentifiersRequest,
  type FundQuantificationSnapshot,
  type FundQuantificationSnapshotSearchRequestRequest,
  type FundQuantificationSnapshotWritable,
  type FundQuantificationSnapshotWriteRequest,
  type FundSearchRequestRequest,
  type FundVariant,
  type FundVariantQuantificationSet,
  type FundVariantQuantificationSetRequest,
  type FundVariantSearchRequestRequest,
  type FundVariantWritable,
  type FundVariantWriteRequest,
  type FundWritable,
  type FundWriteRequest,
  type GeneralMeeting,
  type GeneralMeetingSearchRequestRequest,
  GeneralMeetingTypeEnum,
  type GeneralMeetingWritable,
  type GeneralMeetingWriteRequest,
  GeneralMeetingWriteTypeEnum,
  type GetOrganizationByIdentifierRequestRequest,
  type Holding,
  type HoldingInputRequest,
  type HoldingResponse,
  type HoldingResponseWritable,
  type HoldingWritable,
  IdentifierTypeEnum,
  type Industry,
  type IndustryNaics,
  type IndustryNaicsRequest,
  type IndustryNaicsWritable,
  type IndustryRequest,
  type IndustryWritable,
  type InstitutionalMeetingsearchListData,
  type InstitutionalMeetingsearchListResponse,
  type InstitutionalMeetingsearchListResponses,
  type Instrument,
  type InstrumentSearchRequestRequest,
  type InstrumentWritable,
  type InstrumentWriteRequest,
  type InvestorAccountVoteInfo,
  type InvestorPolicySii,
  type InvestorPolicySiiBatchCreateRequest,
  type InvestorPolicySiiBatchDeleteRequest,
  type InvestorPolicySiiInputRequest,
  type InvestorPolicySiiResponse,
  type InvestorPolicySiiResponseWritable,
  type InvestorPolicySiiSearchRequestRequest,
  type InvestorPolicySiiWritable,
  type InvestorRulesEngine,
  type InvestorRulesEngineRequest,
  type InvestorRulesEngineWritable,
  type InvestorsCanVoteRequest,
  type InvestorsCanVoteResponse,
  type InvestorSiiBatchCreateRequest,
  type InvestorSiiBatchDeleteRequest,
  type InvestorSiiInputRequest,
  type InvestorSiiResponse,
  type InvestorSiiResponseWritable,
  type InvestorSiiSearchRequestRequest,
  type InvestorSupportedIssuedInstrument,
  type InvestorSupportedIssuedInstrumentWritable,
  type MatchVotingRecommendationFromPvrRequest,
  type Meeting,
  type MeetingBallot,
  type MeetingBallotSource,
  type MeetingBallotSourceWritable,
  type MeetingBallotWritable,
  MeetingTypeEnum,
  type MeetingWritable,
  type MinimalInstrument,
  type MinimalInstrumentWritable,
  type Organization,
  type OrganizationAddress,
  type OrganizationAddressRequest,
  type OrganizationBio,
  type OrganizationBioRequest,
  type OrganizationIdentifier,
  type OrganizationIdentifierRequest,
  type OrganizationLogoUploadRequest,
  type OrganizationSearchRequestRequest,
  type OrganizationWritable,
  type OrganizationWriteRequest,
  type PaginatedAuditEventList,
  type PaginatedAuditEventListWritable,
  type PaginatedBallotEntitlementList,
  type PaginatedBallotEntitlementListWritable,
  type PaginatedFundList,
  type PaginatedFundListWritable,
  type PaginatedFundManagerList,
  type PaginatedFundManagerListWritable,
  type PaginatedFundManagerPolicySiiList,
  type PaginatedFundManagerPolicySiiListWritable,
  type PaginatedFundManagerSupportedVotingPolicyHistoricalList,
  type PaginatedFundQuantificationSnapshotList,
  type PaginatedFundQuantificationSnapshotListWritable,
  type PaginatedFundVariantList,
  type PaginatedFundVariantListWritable,
  type PaginatedGeneralMeetingList,
  type PaginatedGeneralMeetingListWritable,
  type PaginatedInstrumentList,
  type PaginatedInstrumentListWritable,
  type PaginatedInvestorPolicySiiList,
  type PaginatedInvestorPolicySiiListWritable,
  type PaginatedInvestorSupportedIssuedInstrumentList,
  type PaginatedInvestorSupportedIssuedInstrumentListWritable,
  type PaginatedMeetingBallotList,
  type PaginatedMeetingBallotListWritable,
  type PaginatedMeetingBallotSourceList,
  type PaginatedMeetingBallotSourceListWritable,
  type PaginatedMeetingList,
  type PaginatedMeetingListWritable,
  type PaginatedOrganizationList,
  type PaginatedOrganizationListWritable,
  type PaginatedPiBallotSearchList,
  type PaginatedPiBallotSearchListWritable,
  type PaginatedPiMeetingSearchList,
  type PaginatedPiMeetingSearchListWritable,
  type PaginatedProposalList,
  type PaginatedProposalListWritable,
  type PaginatedProviderList,
  type PaginatedProviderListWritable,
  type PaginatedProviderVotingRecommendationList,
  type PaginatedPublicSecurityIdList,
  type PaginatedPublicSecurityIdListWritable,
  type PaginatedRulesEngineDefinitionList,
  type PaginatedRulesEngineDefinitionListWritable,
  type PaginatedRulesEngineRuleList,
  type PaginatedRulesEngineRuleListWritable,
  type PaginatedSplitVoteInstructionOverwriteReasonList,
  type PaginatedVotingPolicyDocumentList,
  type PaginatedVotingPolicyDocumentListWritable,
  type PaginatedVotingPolicyList,
  type PaginatedVotingPolicyListWritable,
  type PaginatedVotingRecommendationList,
  type PaginatedVotingRecommendationListWritable,
  type PatchedGeneralMeetingWriteRequest,
  type PatchedOrganizationWriteRequest,
  type PatchedProposalPatchRequest,
  type PatchedVotingPolicyDocumentUpdateRequest,
  type PatchedVotingPolicyUpdateRequest,
  type PatchedVotingRecommendationUpdateRequest,
  type PiBallotSearch,
  type PiBallotSearchWritable,
  type PiMeetingSearch,
  type PiMeetingSearchWritable,
  type Policy,
  PolicyInstructionEnum,
  type PolicyRequest,
  type PolicyResponse,
  type PolicyResponseWritable,
  type PolicyWritable,
  ProductEnum,
  type Proposal,
  type ProposalClassificationCodesResponse,
  type ProposalCountRequestRequest,
  type ProposalCountResponse,
  type ProposalFetchNamesFromIdsRequestRequest,
  type ProposalFetchNamesFromIdsResponse,
  type ProposalFetchRequestRequest,
  type ProposalManagementRecommendation,
  type ProposalManagementRecommendationRequest,
  type ProposalOutcome,
  type ProposalOutcomeRequest,
  type ProposalOutcomeWritable,
  type ProposalPassThreshold,
  type ProposalPassThresholdRequest,
  type ProposalSearchRequestRequest,
  type ProposalSecClassificationCodesResponse,
  type ProposalVotes,
  type ProposalVotesRequest,
  type ProposalWritable,
  type ProposalWriteRequest,
  type Provider,
  type ProviderVotingRecommendation,
  type ProviderVotingRecommendationCreateRequest,
  type ProviderVotingRecommendationListResponse,
  type ProviderVotingRecommendationSearchRequest,
  type ProviderWritable,
  type ProviderWriteRequest,
  ProxyIntermediaryEnum,
  type ProxyIntermediaryProposalLabelsAssignCreateData,
  type ProxyIntermediaryProposalLabelsAssignCreateResponse,
  type ProxyIntermediaryProposalLabelsAssignCreateResponses,
  type ProxyIntermediaryProposalLabelsFetchCreateData,
  type ProxyIntermediaryProposalLabelsFetchCreateResponse,
  type ProxyIntermediaryProposalLabelsFetchCreateResponses,
  type ProxySubmission,
  type ProxySubmissionRequest,
  type ProxyvotingEntitlementsBreakdownCreateData,
  type ProxyvotingEntitlementsBreakdownCreateResponse,
  type ProxyvotingEntitlementsBreakdownCreateResponses,
  type ProxyvotingEntitlementsComputeCreateData,
  type ProxyvotingEntitlementsComputeCreateResponse,
  type ProxyvotingEntitlementsComputeCreateResponses,
  type ProxyvotingEntitlementsListData,
  type ProxyvotingEntitlementsListResponse,
  type ProxyvotingEntitlementsListResponses,
  type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData,
  type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
  type ProxyvotingFundManagerSupportedPoliciesCreateData,
  type ProxyvotingFundManagerSupportedPoliciesCreateResponse,
  type ProxyvotingFundManagerSupportedPoliciesCreateResponses,
  type ProxyvotingFundManagerSupportedPoliciesDestroyData,
  type ProxyvotingFundManagerSupportedPoliciesDestroyResponse,
  type ProxyvotingFundManagerSupportedPoliciesDestroyResponses,
  type ProxyvotingFundManagerSupportedPoliciesListData,
  type ProxyvotingFundManagerSupportedPoliciesListResponse,
  type ProxyvotingFundManagerSupportedPoliciesListResponses,
  type ProxyvotingInvestorCompositionsDifferenceListData,
  type ProxyvotingInvestorCompositionsDifferenceListResponse,
  type ProxyvotingInvestorCompositionsDifferenceListResponses,
  type ProxyvotingInvestorCompositionsRenderCreateData,
  type ProxyvotingInvestorCompositionsRenderCreateResponse,
  type ProxyvotingInvestorCompositionsRenderCreateResponses,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveData,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateData,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateResponse,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateResponses,
  type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData,
  type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
  type ProxyvotingMeetingballotsComputeCreateData,
  type ProxyvotingMeetingballotsComputeCreateResponse,
  type ProxyvotingMeetingballotsComputeCreateResponses,
  type ProxyvotingMeetingBallotsListData,
  type ProxyvotingMeetingBallotsListResponse,
  type ProxyvotingMeetingBallotsListResponses,
  type ProxyvotingMeetingBallotSourcesListData,
  type ProxyvotingMeetingBallotSourcesListResponse,
  type ProxyvotingMeetingBallotSourcesListResponses,
  type ProxyvotingPiballotsFilterListData,
  type ProxyvotingPiballotsFilterListResponse,
  type ProxyvotingPiballotsFilterListResponses,
  type ProxyvotingPiballotsInvestorsCanVoteCreateData,
  type ProxyvotingPiballotsInvestorsCanVoteCreateResponse,
  type ProxyvotingPiballotsInvestorsCanVoteCreateResponses,
  type ProxyvotingPimeetingsFilterListData,
  type ProxyvotingPimeetingsFilterListResponse,
  type ProxyvotingPimeetingsFilterListResponses,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyData,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsCreateData,
  type ProxyvotingRulesEngineDefinitionsCreateResponse,
  type ProxyvotingRulesEngineDefinitionsCreateResponses,
  type ProxyvotingRulesEngineDefinitionsDestroyData,
  type ProxyvotingRulesEngineDefinitionsDestroyErrors,
  type ProxyvotingRulesEngineDefinitionsDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsListData,
  type ProxyvotingRulesEngineDefinitionsListResponse,
  type ProxyvotingRulesEngineDefinitionsListResponses,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveData,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponse,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses,
  type ProxyvotingRulesEngineDefinitionsRetrieveData,
  type ProxyvotingRulesEngineDefinitionsRetrieveResponse,
  type ProxyvotingRulesEngineDefinitionsRetrieveResponses,
  type ProxyvotingRulesEngineDefinitionsRulesCreateData,
  type ProxyvotingRulesEngineDefinitionsRulesCreateResponse,
  type ProxyvotingRulesEngineDefinitionsRulesCreateResponses,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyData,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsRulesListData,
  type ProxyvotingRulesEngineDefinitionsRulesListResponse,
  type ProxyvotingRulesEngineDefinitionsRulesListResponses,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateData,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateResponse,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateResponses,
  type ProxyvotingSviProposalOverwriteCreateData,
  type ProxyvotingSviProposalOverwriteCreateResponse,
  type ProxyvotingSviProposalOverwriteCreateResponses,
  type ProxyvotingSviProposalOverwriteReasonsListData,
  type ProxyvotingSviProposalOverwriteReasonsListResponse,
  type ProxyvotingSviProposalOverwriteReasonsListResponses,
  type PublicSecurityId,
  type PublicSecurityIdListQueryRequest,
  type PublicSecurityIdWritable,
  type Quantification,
  type QuantificationRequest,
  RecommendationEnum,
  type RenderCompositionDifferenceRequest,
  ReportableReasonEnum,
  type RulesEngineDefinition,
  type RulesEngineDefinitionCreateRequest,
  type RulesEngineDefinitionWritable,
  type RulesEngineNamesResponse,
  type RulesEngineRule,
  type RulesEngineRuleWritable,
  type RulesEngineRuleWriteRequest,
  RuleTypeEnum,
  type SelectedPolicy,
  type SelectedPolicyRequestRequest,
  type SelectedPolicyResponse,
  type SelectedPolicyResponseWritable,
  type SelectedPolicyWritable,
  SourceEnum,
  type SplitVoteInstructionOverwriteReason,
  type SplitVoteInstructionProposalOverwrite,
  type SplitVoteInstructionProposalOverwriteRequest,
  type SplitVoteInstructionProposalOverwriteWritable,
  StatusEnum,
  type SupportedIssuedInstrumentsQueryRequest,
  type TaskStatus,
  type TaskTriggered,
  type TransparencyAuditEventsSearchCreateData,
  type TransparencyAuditEventsSearchCreateResponse,
  type TransparencyAuditEventsSearchCreateResponses,
  type TransparencyExternalMeetingIdsCreateData,
  type TransparencyExternalMeetingIdsCreateResponse,
  type TransparencyExternalMeetingIdsCreateResponses,
  type TransparencyExternalMeetingIdsDestroyData,
  type TransparencyExternalMeetingIdsDestroyResponse,
  type TransparencyExternalMeetingIdsDestroyResponses,
  type TransparencyGeneralMeetingsCreateData,
  type TransparencyGeneralMeetingsCreateResponse,
  type TransparencyGeneralMeetingsCreateResponses,
  type TransparencyGeneralMeetingsPartialUpdateData,
  type TransparencyGeneralMeetingsPartialUpdateResponse,
  type TransparencyGeneralMeetingsPartialUpdateResponses,
  type TransparencyGeneralMeetingsRetrieveData,
  type TransparencyGeneralMeetingsRetrieveResponse,
  type TransparencyGeneralMeetingsRetrieveResponses,
  type TransparencyGeneralMeetingsSearchCreateData,
  type TransparencyGeneralMeetingsSearchCreateResponse,
  type TransparencyGeneralMeetingsSearchCreateResponses,
  type TransparencyInstrumentsCreateData,
  type TransparencyInstrumentsCreateResponse,
  type TransparencyInstrumentsCreateResponses,
  type TransparencyInstrumentsDestroyData,
  type TransparencyInstrumentsDestroyResponse,
  type TransparencyInstrumentsDestroyResponses,
  type TransparencyInstrumentsFetchMinimalCreateData,
  type TransparencyInstrumentsFetchMinimalCreateResponse,
  type TransparencyInstrumentsFetchMinimalCreateResponses,
  type TransparencyInstrumentsRetrieveData,
  type TransparencyInstrumentsRetrieveResponse,
  type TransparencyInstrumentsRetrieveResponses,
  type TransparencyInstrumentsSearchCreateData,
  type TransparencyInstrumentsSearchCreateResponse,
  type TransparencyInstrumentsSearchCreateResponses,
  type TransparencyInstrumentsUnassociatedRetrieveData,
  type TransparencyInstrumentsUnassociatedRetrieveResponse,
  type TransparencyInstrumentsUnassociatedRetrieveResponses,
  type TransparencyInstrumentsUpdateData,
  type TransparencyInstrumentsUpdateResponse,
  type TransparencyInstrumentsUpdateResponses,
  type TransparencyOrganizationsCreateData,
  type TransparencyOrganizationsCreateResponse,
  type TransparencyOrganizationsCreateResponses,
  type TransparencyOrganizationsDestroyData,
  type TransparencyOrganizationsDestroyResponse,
  type TransparencyOrganizationsDestroyResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsCreateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData,
  type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
  type TransparencyOrganizationsGeneralMeetingsProposalsUpdateData,
  type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse,
  type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
  type TransparencyOrganizationsGetByIdentifierCreateData,
  type TransparencyOrganizationsGetByIdentifierCreateResponse,
  type TransparencyOrganizationsGetByIdentifierCreateResponses,
  type TransparencyOrganizationsIsinsToNamesCreateData,
  type TransparencyOrganizationsIsinsToNamesCreateResponse,
  type TransparencyOrganizationsIsinsToNamesCreateResponses,
  type TransparencyOrganizationsLogoCreateData,
  type TransparencyOrganizationsLogoCreateResponse,
  type TransparencyOrganizationsLogoCreateResponses,
  type TransparencyOrganizationsPartialUpdateData,
  type TransparencyOrganizationsPartialUpdateResponse,
  type TransparencyOrganizationsPartialUpdateResponses,
  type TransparencyOrganizationsRetrieveData,
  type TransparencyOrganizationsRetrieveResponse,
  type TransparencyOrganizationsRetrieveResponses,
  type TransparencyOrganizationsSearchCreateData,
  type TransparencyOrganizationsSearchCreateResponse,
  type TransparencyOrganizationsSearchCreateResponses,
  type TransparencyOrganizationsUpdateData,
  type TransparencyOrganizationsUpdateResponse,
  type TransparencyOrganizationsUpdateResponses,
  type TransparencyProposalsClassificationCodesRetrieveData,
  type TransparencyProposalsClassificationCodesRetrieveResponse,
  type TransparencyProposalsClassificationCodesRetrieveResponses,
  type TransparencyProposalsCountCreateData,
  type TransparencyProposalsCountCreateResponse,
  type TransparencyProposalsCountCreateResponses,
  type TransparencyProposalsFetchCreateData,
  type TransparencyProposalsFetchCreateResponse,
  type TransparencyProposalsFetchCreateResponses,
  type TransparencyProposalsFetchNamesFromIdsCreateData,
  type TransparencyProposalsFetchNamesFromIdsCreateResponse,
  type TransparencyProposalsFetchNamesFromIdsCreateResponses,
  type TransparencyProposalsSecClassificationCodesRetrieveData,
  type TransparencyProposalsSecClassificationCodesRetrieveResponse,
  type TransparencyProposalsSecClassificationCodesRetrieveResponses,
  type TransparencyPublicSecurityIdsSearchCreateData,
  type TransparencyPublicSecurityIdsSearchCreateResponse,
  type TransparencyPublicSecurityIdsSearchCreateResponses,
  type TriggerComputeEntitlementsRequest,
  type TriggerProcessMeetingBallotsRequest,
  type UnassociatedInstrumentsResponse,
  type UnassociatedInstrumentsResponseWritable,
  UpdateMaskEnum,
  type UpdateVotingRecommendationFromPvrRequest,
  ValidEnum,
  type VoterDetailsResponse,
  type VoterResponse,
  type VoterResponseWritable,
  VoterTypeEnum,
  type VoterWithHoldingsInputRequest,
  type VoterWithHoldingsResponse,
  type VoterWithHoldingsResponseWritable,
  VotingInstructionEnum,
  type VotingOperationsPiballotsFilterListData,
  type VotingOperationsPiballotsFilterListResponse,
  type VotingOperationsPiballotsFilterListResponses,
  type VotingOperationsPimeetingsFilterListData,
  type VotingOperationsPimeetingsFilterListResponse,
  type VotingOperationsPimeetingsFilterListResponses,
  VotingOptionsEnum,
  type VotingPolicy,
  type VotingPolicyCreateRequest,
  type VotingPolicyDocument,
  type VotingPolicyDocumentWritable,
  type VotingPolicyProviderVotingRecommendationsCreateData,
  type VotingPolicyProviderVotingRecommendationsCreateResponse,
  type VotingPolicyProviderVotingRecommendationsCreateResponses,
  type VotingPolicyProviderVotingRecommendationsDestroyData,
  type VotingPolicyProviderVotingRecommendationsDestroyResponse,
  type VotingPolicyProviderVotingRecommendationsDestroyResponses,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
  type VotingPolicyProviderVotingRecommendationsMatchCreateData,
  type VotingPolicyProviderVotingRecommendationsMatchCreateResponse,
  type VotingPolicyProviderVotingRecommendationsMatchCreateResponses,
  type VotingPolicyProviderVotingRecommendationsSearchCreateData,
  type VotingPolicyProviderVotingRecommendationsSearchCreateResponse,
  type VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
  type VotingPolicySearchRequest,
  type VotingPolicyVotingPoliciesCreateData,
  type VotingPolicyVotingPoliciesCreateResponse,
  type VotingPolicyVotingPoliciesCreateResponses,
  type VotingPolicyVotingPoliciesDestroyData,
  type VotingPolicyVotingPoliciesDestroyResponse,
  type VotingPolicyVotingPoliciesDestroyResponses,
  type VotingPolicyVotingPoliciesDocumentsCreateData,
  type VotingPolicyVotingPoliciesDocumentsCreateResponse,
  type VotingPolicyVotingPoliciesDocumentsCreateResponses,
  type VotingPolicyVotingPoliciesDocumentsListData,
  type VotingPolicyVotingPoliciesDocumentsListResponse,
  type VotingPolicyVotingPoliciesDocumentsListResponses,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateData,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses,
  type VotingPolicyVotingPoliciesDocumentsRetrieveData,
  type VotingPolicyVotingPoliciesDocumentsRetrieveResponse,
  type VotingPolicyVotingPoliciesDocumentsRetrieveResponses,
  type VotingPolicyVotingPoliciesPartialUpdateData,
  type VotingPolicyVotingPoliciesPartialUpdateResponse,
  type VotingPolicyVotingPoliciesPartialUpdateResponses,
  type VotingPolicyVotingPoliciesRetrieveData,
  type VotingPolicyVotingPoliciesRetrieveResponse,
  type VotingPolicyVotingPoliciesRetrieveResponses,
  type VotingPolicyVotingPoliciesSearchCreateData,
  type VotingPolicyVotingPoliciesSearchCreateResponse,
  type VotingPolicyVotingPoliciesSearchCreateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyData,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsListData,
  type VotingPolicyVotingPoliciesVotingRecommendationsListResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsListResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateData,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
  type VotingPolicyWritable,
  type VotingRecommendation,
  type VotingRecommendationConfidenceScore,
  type VotingRecommendationConfidenceScoreUpsertRequest,
  type VotingRecommendationCreateRequest,
  type VotingRecommendationSearchRequest,
  type VotingRecommendationWritable,
} from './types.gen'
